var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRudiobuttonCheckedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59999 15.1663C4.64665 15.1663 1.43332 11.953 1.43332 7.99967C1.43332 4.04634 4.64665 0.833008 8.59999 0.833008C12.5533 0.833008 15.7667 4.04634 15.7667 7.99967C15.7667 11.953 12.5533 15.1663 8.59999 15.1663ZM8.59999 1.83301C5.19999 1.83301 2.43332 4.59967 2.43332 7.99967C2.43332 11.3997 5.19999 14.1663 8.59999 14.1663C12 14.1663 14.7667 11.3997 14.7667 7.99967C14.7667 4.59967 12 1.83301 8.59999 1.83301Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65361 10.3863C7.52027 10.3863 7.39361 10.333 7.30027 10.2397L5.41361 8.35299C5.22027 8.15966 5.22027 7.83966 5.41361 7.64633C5.60694 7.45299 5.92694 7.45299 6.12027 7.64633L7.65361 9.17966L11.0803 5.75299C11.2736 5.55966 11.5936 5.55966 11.7869 5.75299C11.9803 5.94633 11.9803 6.26632 11.7869 6.45966L8.00694 10.2397C7.91361 10.333 7.78694 10.3863 7.65361 10.3863Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRudiobuttonCheckedBlue);
export default __webpack_public_path__ + "static/media/rudiobutton-checked-blue.7db6386ff481844f432e94381d68fbe3.svg";
export { ForwardRef as ReactComponent };